export const MANAGE_REPAYMENTS_INCREASE_ROUTE = {
  INCREASE: "/increase",
  INCREASE_EXTRA: "/extra",
  INCREASE_DOUBLE: "/double",
  INCREASE_HIGHER: "/higher",
};

export const MANAGE_ARREARS_ROUTE = {
  ARREARS: "/arrears",
  PAY_FULL: "/pay-full",
  PAY_FULL_OVER_REST_OF_LOAN: "/pay-full-rest-of-loan",
  PAY_FULL_THREE_REPAYMENTS: "/pay-full-three-repayments",
  PAY_EXTRA: "/extra",
  PAY_DOUBLE: "/double",
};

export const EXTRA_REPAYMENTS_ROUTE = {
  DIRECT_DEBIT: "/extra/direct-debit",
  DEBIT_CARD: "/extra/debit-card",
  BANK_TRANSFER: "/extra/bank-transfer",
};

export const PAY_FULL_ARREARS_ROUTE = {
  DIRECT_DEBIT: "/pay-full/direct-debit",
  DEBIT_CARD: "/pay-full/debit-card",
  BANK_TRANSFER: "/pay-full/bank-transfer",
};